module.exports = __webpack_public_path__ + "assets/img/11.67ca94a9.png";